import { createFeatureSelector } from '@ngrx/store';

import { MODULE_KEY } from '../../constants';
import { MemberState } from '../reducers';

export const selectMemberModuleState =
  createFeatureSelector<MemberState>(MODULE_KEY);
